import { HiX } from "react-icons/hi";
import Links from "./components/Links";
import routes from "routes";
import lightningChecksLogo from "../../assets/img/mainlogo.png";
import bm2bankLogo from "../../assets/img/paxum.svg";
import bm2payLogo from "../../assets/img/bm2pay.svg";
import { useParams } from "react-router-dom";
import { Modal, ModalContent,ModalBody, ModalOverlay } from "@chakra-ui/modal";
import Card from "components/card";
import { useContext, useEffect, useState } from "react";
import { ClientContext } from "ClientProvider";
import {getSettings} from "api/settings"


let mainlogo: string = bm2payLogo;

if (window.location.hostname === "gateway-dev.lightningchecks.com" || window.location.hostname === "gateway.lightningchecks.com" || window.location.hostname === "testing.lightningchecks.com") {
    mainlogo = lightningChecksLogo;
} else if (window.location.hostname === "gateway-dev.bm2pay.com" || window.location.hostname === "gateway.bm2pay.com") {
    mainlogo = bm2payLogo;
} else if (window.location.hostname === "pay.paxum.com") {
    mainlogo = bm2bankLogo;
} else if (window.location.hostname === "gateway-stagging.bm2pay.com") {
    mainlogo = bm2payLogo;
} else {
    mainlogo = bm2payLogo;
}

const Sidebar = (props: {
  open: boolean;
  onClose: React.MouseEventHandler<HTMLSpanElement>;
}) => {
  const { open, onClose } = props;
  const [portalIcon, setPortalIcon] = useState<string | null>(mainlogo);

  const clientId = localStorage.getItem("clietnIds");
    const {
      SettlementAPISttus,
      setisOpenSettlementAPISttus,
      isOpenSettlementAPISttus,
      setSettlementAPISttus,
    } = useContext(ClientContext);
  const updatedRoutes = routes.map((route) => {
    if (route.name === "Smart Routing") {
      return {
        ...route,
        isHidden: clientId === null ? true : false,
        hideInSidebar: clientId === null ? true : false,
      };
    }

    return route;
  });

  const fetchSettings = () => {
      getSettings(false)
      .then((data) => {
          setPortalIcon(data.portal_icon)
      })
      .catch((err) => {
        
      })
      .finally(() => {
      });
  };
  
    useEffect(() => {
      fetchSettings();
    }, []);

  return (
    <div
      className={`sm:none duration-175 linear fixed !z-50 flex min-h-full flex-col bg-white pb-10 shadow-2xl shadow-white/5 transition-all dark:!bg-navy-800 dark:text-white md:!z-50 lg:!z-50 xl:!z-0 ${
        open ? "translate-x-0" : "-translate-x-96"
      }`}
    >
      <span
        className="absolute right-4 top-4 block cursor-pointer xl:hidden"
        onClick={onClose}
      >
        <HiX />
      </span>
      {(window.location.hostname === "gateway-dev.lightningchecks.com" || window.location.hostname === "gateway.lightningchecks.com" || window.location.hostname === "testing.lightningchecks.com") && (
      <div className={`ml-[30px] mr-[40px] mt-[47px] flex items-center justify-center`} >
        <img src={portalIcon} className="h-full w-10 object-cover" alt="main-logo" id="portalIcon"/>
        <div className="flex flex-col  font-poppins text-[20px] font-bold uppercase text-navy-700 dark:text-white">
          lightning
          <span className="text-sm font-light">checks</span>
        </div>
      </div>
      )}
      {(window.location.hostname === "gateway-dev.bm2pay.com" || window.location.hostname === "gateway.bm2pay.com" || window.location.hostname === "pay.paxum.com" || window.location.hostname === "gateway-stagging.bm2pay.com") && (
      <div className={`ml-[30px] mr-[40px] mt-[30px] flex items-center justify-center`} >
        <img src={portalIcon} className="h-full w-20  object-cover" alt="main-logo"  id="portalIcon"/>
      </div>
      )}
      {!(["gateway-dev.lightningchecks.com", "gateway.lightningchecks.com", "gateway-dev.bm2pay.com", "gateway.bm2pay.com", "pay.paxum.com", "gateway-stagging.bm2pay.com"].includes(window.location.hostname)) && (
        <div className="ml-[30px] mr-[40px] mt-[30px] flex items-center justify-center">
          <img src={portalIcon} className="h-full w-20  object-cover" alt="main-logo"  id="portalIcon"/>
        </div>
      )}
      {(window.location.hostname === "gateway-dev.lightningchecks.com" || window.location.hostname === "gateway.lightningchecks.com" || window.location.hostname === "testing.lightningchecks.com") && (
        <div className="mb-7 mt-[50px] h-px bg-gray-300 dark:bg-white/30" />
      )}
      {(window.location.hostname === "gateway-dev.bm2pay.com" || window.location.hostname === "gateway.bm2pay.com" || window.location.hostname === "pay.paxum.com" || window.location.hostname === "gateway-stagging.bm2pay.com") && (
       <div className="mb-7 mt-[38px] h-px bg-gray-300 dark:bg-white/30" /> 
      )}
      {!(["gateway-dev.lightningchecks.com", "gateway.lightningchecks.com", "gateway-dev.bm2pay.com", "gateway.bm2pay.com", "pay.paxum.com", "backend-stagging.bm2pay.com"].includes(window.location.hostname)) && (
        <div className="mb-7 mt-[38px] h-px bg-gray-300 dark:bg-white/30" /> 
      )}
      
      <ul
        onMouseEnter={() => {
          if (SettlementAPISttus == "in-progress") {
            setisOpenSettlementAPISttus(true);
          } else {
            setisOpenSettlementAPISttus(false);
          }
        }} 
        className="mb-auto max-h-[75vh] overflow-auto pt-1 scrollbar-hide"
      >
        <Links
          routes={updatedRoutes.filter((data) => data.layout === "/admin")}
        />
      </ul>
      <Modal isOpen={isOpenSettlementAPISttus} onClose={() => {}}>
        <ModalOverlay className="bg-[#000] !opacity-30" />

        <ModalContent className="sm:max-w-xxl scrollbarhide z-[1002]  !m-auto flex max-h-[100vh] min-h-[85vh] max-w-[800px] justify-start   overflow-auto !p-3 sm:my-8 sm:w-full ">
          <ModalBody>
            <Card extra=" max-w-[800px] sm:w-full flex flex-col justify-start !z-[1004]    scrollbarhide overflow-auto">
              <h5 className="p-5 px-[30px] text-2xl font-bold">
                Settlemnet Report is being created.
              </h5>
              <div className="mt-5 flex gap-2 px-[30px] pb-[30px]">
                <button
                  onClick={() => {
                    setisOpenSettlementAPISttus(false);
                  }}
                  className="linear rounded-xl bg-gray-100 px-5 py-2 text-base font-medium text-navy-700 outline-none transition duration-200 hover:bg-gray-200 active:bg-gray-300 dark:bg-white/10 dark:text-white dark:hover:bg-white/20 dark:active:bg-white/30"
                >
                  Close
                </button>

                <button
                  onClick={() => {
                    setisOpenSettlementAPISttus(false);
                  }}
                  className="linear rounded-xl bg-indigo-50 px-5 py-2 text-base font-medium text-indigo-500 outline-none transition duration-200 hover:bg-indigo-600/5 active:bg-indigo-700/5 dark:bg-indigo-400/10 dark:text-white dark:hover:bg-indigo-300/10 dark:active:bg-indigo-200/10"
                >
                  <a target="_blank" href="/">
                    Open in New TAB
                  </a>
                </button>
              </div>
            </Card>
          </ModalBody>
        </ModalContent>
      </Modal>

      {/* Nav item end */}
    </div>
  );
};

export default Sidebar;
